(() => {
    const elHtml = document.documentElement;

    document.addEventListener('keydown', (ev) => {
        if (ev.key === 'Tab') {
            elHtml.classList.add('user-is-tabbing');
        }
    });

    document.addEventListener('mousedown', () => {
        elHtml.classList.remove('user-is-tabbing');
    });
})();
